import React, { useEffect, useState, useContext } from 'react'
import { components } from 'cng-web-lib'
import { FormControl, Grid, Select, Paper, Box, InputLabel } from '@material-ui/core'
import ACEHighwayShipmentTranslationText from '../../contexts/ACEHighwayShipmentTranslationText'

const {
    button: { CngButton },
    CngDialog
} = components

function Sec321AmountExceededDialog(props) {
    const { messages, onClose, onSubmit, open, shipment, shipments, data } = props

    const aceHighwayShipmentTranslationText = ACEHighwayShipmentTranslationText() 

    let showProceedButtonFlag = showProceedButton()

    function showProceedButton(){
         for (let message in messages) {
            if(messages[message].includes('consignee name') || messages[message].includes('consignee address')){
                return false
            }
         }
         return true;
    }

    function showMessages() {
        let content = []

        for (let message in messages) {
            content.push(
                <Grid item xs={12}>
                    {messages[message]}
                </Grid>
            )
        }

        return content
    }

    return (
        <CngDialog
            dialogContent={
                <Grid container spacing={2}>
                    {showMessages()}
                </Grid>
            }
            dialogAction={
                <>
                    <CngButton color='secondary' onClick={onClose} size='medium'>{aceHighwayShipmentTranslationText.backButton}</CngButton>
                    { showProceedButtonFlag && 
                        <CngButton
                            color='primary'
                            onClick={() => {
                                onSubmit(shipment != null ? shipment : data != null ? data : shipments)
                                onClose()
                            }}
                            size='medium'
                        >{aceHighwayShipmentTranslationText.proceedButton}</CngButton>
                    }
                </>
            }
            dialogTitle={aceHighwayShipmentTranslationText.monetaryAmountExceededLimit}
            fullWidth
            maxWidth='md'
            onClose={onClose}
            open={open}
            shouldShowCloseButton
        />
    )
}

export default Sec321AmountExceededDialog